import HomeIcon from '../assets/icons/Home';
import RoomIcon from '../assets/icons/Room';
import MoreIcon from '../assets/icons/More';
import ClockIcon from '../assets/icons/Clock';
import LoginIcon from '../assets/icons/Login';
import FolderIcon from '../assets/icons/Folder';
import SalesLawIcon from '../assets/icons/NewSalesLawIcon';
import PrivateSharingMenuIcon from '../assets/icons/PrivateSharingMenuIcon';
import HomeIconActive from '../assets/icons/HomeActive';
import ClockIconActive from '../assets/icons/ClockActive';
import FolderIconActive from '../assets/icons/FolderActive';
import MoreIconActive from '../assets/icons/MoreActive';
import VerdiIcon from '../assets/icons/VerdiIcon';
import FindProfesionalIcon from '../assets/icons/FindProfessional';
import { enableAddOn } from '../config';
import { experimentTemplateData } from '../views/PrivateRoutes/Dashboard/ExperimentTemplate/util';

export const privateNavbarMenu = [
  {
    title: 'Hjem',
    icon: HomeIcon,
    activeIcon: HomeIconActive,
    link: 'home',
  },
  {
    title: 'Verdi',
    icon: VerdiIcon,
    link: 'financials',
    desktopOnly: true,
  },
  {
    title: 'Historikk',
    icon: ClockIcon,
    activeIcon: ClockIconActive,
    link: 'history',
  },
  {
    title: 'Dokumenter',
    icon: FolderIcon,
    activeIcon: FolderIconActive,
    link: 'documents',
  },
  {
    title: 'Rom',
    icon: RoomIcon,
    activeIcon: RoomIcon,
    link: 'rooms',
  },
  {
    title: 'Finn håndverker',
    icon: FindProfesionalIcon,
    link: 'more/find-professional',
    desktopOnly: true,
    experimental: false,
  },
  ...(enableAddOn === 'true'
    ? experimentTemplateData
        .map((value) => {
          if (value.menuItem.isEnable)
            return {
              title: value.menuItem.title,
              icon: value.menuItem.icon,
              activeIcon: value.menuItem.activeIcon,
              desktopOnly: true,
              link: `addon/${value.experimentSlug}`,
              isNew: value.menuItem.isNew,
              hideInPrivateProperty: value.menuItem.hideInPrivateProperty,
              hideOnLands: value.menuItem.hideOnLands,
              hideOnGarageBuilding: value.menuItem.hideOnGarageBuilding,
            };
          return null;
        })
        .filter((value) => value)
    : []),
  {
    title: 'Ny boligsalgslov',
    icon: SalesLawIcon,
    link: 'sales-law',
    desktopOnly: true,
    isHide: false,
  },
  {
    title: 'Deling og tilganger',
    icon: PrivateSharingMenuIcon,
    link: 'more/private-share',
    desktopOnly: true,
    experimental: false,
    hideInPrivateProperty: true,
    notificationLabel: true,
  },
  {
    title: 'Mer',
    icon: MoreIcon,
    activeIcon: MoreIconActive,
    link: 'more',
    mobileOnly: true,
    notificationLabel: true,
  },
];

export const publicNavbarMenu = [
  {
    title: 'Hjem',
    icon: HomeIcon,
    activeIcon: HomeIconActive,
    link: 'home',
  },
  {
    title: 'Historikk',
    icon: ClockIcon,
    activeIcon: ClockIconActive,
    link: 'history',
  },
  {
    title: 'Dokumenter',
    icon: FolderIcon,
    activeIcon: FolderIconActive,
    link: 'documents',
  },
  {
    title: 'Rom',
    link: 'rooms',
    icon: RoomIcon,
    activeIcon: RoomIcon,
  },
  {
    title: 'Logg inn',
    icon: LoginIcon,
    activeIcon: LoginIcon,
    link: 'login',
  },
];
